<header class="parent-dialog__header" mat-dialog-title>
  <div class="parent-dialog__header-main">
    <div class="parent-dialog__header-icon" aria-hidden="true">
      <img src="/public/svgs/flag.svg" alt="" width="18" height="18" />
    </div>
    <div class="parent-dialog__header-copy">
      <h2 class="parent-dialog__title">
        {{ 'app.components.routinesDialog.title' | translate }}
      </h2>
      <p class="parent-dialog__subtitle">
        {{ 'app.components.routinesDialog.subtitle' | translate }}
      </p>
    </div>
  </div>
  <button
    type="button"
    class="parent-dialog__close"
    [attr.aria-label]="'app.components.routinesDialog.close' | translate"
    (click)="onDiscard()"
  >
    <img src="/public/svgs/x-close.svg" alt="" width="18" height="18" aria-hidden="true" />
  </button>
</header>

<mat-dialog-content class="parent-dialog__body">
  @if (kids().length > 0) {
    <section class="parent-dialog__section parent-dialog__section--kids">
      <div class="parent-dialog__section-head">
        <span class="parent-dialog__section-label">
          {{ 'app.components.routinesDialog.kidsLabel' | translate }}
        </span>
        <div class="parent-dialog__section-actions">
          @if (selectedKidsCount() > 0) {
            <span class="parent-dialog__section-hint">
              {{ 'app.components.routinesDialog.kidsSelected' | translate: { count: selectedKidsCount() } }}
            </span>
          }
          @if (showKidBulkActions()) {
            <button
              type="button"
              class="parent-dialog__section-action"
              (click)="toggleAllKids()"
            >
              @if (allKidsSelected()) {
                {{ 'app.components.routinesDialog.clearKids' | translate }}
              } @else {
                {{ 'app.components.routinesDialog.selectAllKids' | translate }}
              }
            </button>
          }
        </div>
      </div>
      <div
        class="parent-dialog__kids-scroll"
        tabindex="0"
        role="group"
        [attr.aria-label]="'app.components.routinesDialog.kidsScrollAria' | translate"
      >
        <div class="parent-dialog__kids parent-dialog__kids--strip">
          @for (kid of kids(); track kid.id) {
            <button
              type="button"
              class="parent-dialog__kid"
              [class.parent-dialog__kid--selected]="isKidSelected(kid.id)"
              [attr.aria-pressed]="isKidSelected(kid.id)"
              (click)="toggleKidSelection(kid.id)"
            >
              <span class="parent-dialog__kid-avatar">
                @if (kid.avatar) {
                  <img [src]="kid.avatar" [alt]="kid.firstName" />
                } @else {
                  <span>{{ { firstName: kid.firstName, lastName: kid.lastName } | initials }}</span>
                }
              </span>
              <span class="parent-dialog__kid-name">{{ kid.firstName }}</span>
            </button>
          }
        </div>
      </div>
    </section>
  }

  <section class="parent-dialog__section apply-template__options">
    <span class="parent-dialog__section-label">
      {{ 'app.components.routinesDialog.startersLabel' | translate }}
    </span>
    <ul
      class="apply-template__list"
      role="listbox"
      [attr.aria-label]="'app.components.routinesDialog.startersLabel' | translate"
    >
      @for (starter of starters; track starter.id) {
        <li class="apply-template__row">
          <button
            type="button"
            class="apply-template__select"
            role="option"
            [class.apply-template__select--selected]="isStarterSelected(starter.id)"
            [attr.aria-selected]="isStarterSelected(starter.id)"
            (click)="selectStarter(starter.id)"
          >
            <span class="apply-template__icon apply-template__icon--starter" aria-hidden="true">
              <img src="/public/svgs/recurrence-daily.svg" alt="" width="18" height="18" />
            </span>
            <span class="apply-template__copy">
              <span class="apply-template__name">{{ starter.nameKey | translate }}</span>
              <span class="apply-template__meta">
                {{ starter.hintKey | translate }}
                ·
                {{ 'app.components.routinesDialog.itemCount' | translate: { count: starterItemCount(starter.id) } }}
              </span>
            </span>
          </button>
        </li>
      }
    </ul>
  </section>

  <section class="parent-dialog__section apply-template__options">
    <span class="parent-dialog__section-label">
      {{ 'app.components.routinesDialog.savedLabel' | translate }}
    </span>

    @if (isLoadingSaved()) {
      <p class="apply-template__message">
        {{ 'app.components.routinesDialog.loadingSaved' | translate }}
      </p>
    } @else if (savedTemplates().length === 0) {
      <p class="apply-template__message">
        {{ 'app.components.routinesDialog.savedEmpty' | translate }}
      </p>
    } @else {
      <ul
        class="apply-template__list"
        role="listbox"
        [attr.aria-label]="'app.components.routinesDialog.savedLabel' | translate"
      >
        @for (template of savedTemplates(); track template.id) {
          <li class="apply-template__row">
            <button
              type="button"
              class="apply-template__select"
              role="option"
              [class.apply-template__select--selected]="isSavedSelected(template.id)"
              [attr.aria-selected]="isSavedSelected(template.id)"
              (click)="selectSaved(template)"
            >
              <span class="apply-template__icon" aria-hidden="true">
                <img src="/public/svgs/flag.svg" alt="" width="18" height="18" />
              </span>
              <span class="apply-template__copy">
                <span class="apply-template__name">{{ template.name }}</span>
                <span class="apply-template__meta">
                  {{ 'app.components.routinesDialog.itemCount' | translate: { count: itemCount(template) } }}
                </span>
              </span>
            </button>
            <button
              type="button"
              class="apply-template__edit"
              [attr.aria-label]="'app.components.routinesDialog.editAria' | translate: { name: template.name }"
              (click)="onEditSaved(template, $event)"
            >
              <img src="/public/svgs/edit-dark.svg" alt="" width="14" height="14" aria-hidden="true" />
            </button>
            <button
              type="button"
              class="apply-template__delete"
              [attr.aria-label]="'app.components.routinesDialog.deleteAria' | translate: { name: template.name }"
              (click)="onDeleteSaved(template.id, $event)"
            >
              <img src="/public/svgs/trash-red.svg" alt="" width="14" height="14" aria-hidden="true" />
            </button>
          </li>
        }
      </ul>
    }

    <button type="button" class="apply-template__create-custom" (click)="onCreateCustom()">
      <span class="apply-template__create-icon" aria-hidden="true">+</span>
      <span>{{ 'app.components.routinesDialog.createCustom' | translate }}</span>
    </button>
  </section>

  @if (selectedPreview(); as preview) {
    <section class="parent-dialog__section">
      <span class="parent-dialog__section-label">
        {{ 'app.components.routinesDialog.previewLabel' | translate }}
      </span>
      <ul class="apply-template__preview-list">
        @for (item of preview.items; track $index) {
          <li class="apply-template__preview-item">
            <span class="apply-template__preview-title">{{ item.title }}</span>
            <span class="apply-template__preview-content">{{ item.content }}</span>
          </li>
        }
      </ul>
    </section>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="parent-dialog__actions parent-dialog-actions">
  <app-parent-button variant="ghost" (clicked)="onDiscard()">
    {{ 'app.components.routinesDialog.discard' | translate }}
  </app-parent-button>

  @if (canCustomize()) {
    <app-parent-button variant="ghost" (clicked)="onCustomize()">
      {{ 'app.components.routinesDialog.customize' | translate }}
    </app-parent-button>
  }

  <app-parent-button
    variant="primary"
    [loading]="isSubmitting()"
    [disabled]="!canApply()"
    (clicked)="onApply()"
  >
    @if (!isSubmitting()) {
      <img src="/public/svgs/check-w.svg" alt="" width="14" height="14" aria-hidden="true" />
    }
    {{ 'app.components.routinesDialog.apply' | translate }}
  </app-parent-button>
</mat-dialog-actions>
